import React, { useState } from "react";
import PressForm from "../../components/press/PressForm";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PressService } from "../../services/admin/PressService";
import { useNotification } from "../../context/NotificationContext";

export default function AddPressPage() {
    const navigate = useNavigate();
    const { showNotification } = useNotification();
    const [, setIsSubmitting] = useState(false);

    const handlePublish = async (data) => {
        setIsSubmitting(true);
        try {
            // Mapping frontend 'date' to backend 'date_display' and 'logo' to 'logo_path'
            const payload = {
                ...data,
                date_display: data.date,
                logo_path: data.logo
            };
            const response = await PressService.createPress(payload);
            if (response.status === "success") {
                showNotification({ message: "Press coverage published successfully", type: "success" });
                navigate("/admin/press");
            } else {
                showNotification({
                    type: "failed",
                    title: "Error",
                    message: "Failed to save press item."
                });
            }
        } catch (error) {
            showNotification({ message: "An error occurred while publishing", type: "error" });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="p-6 lg:p-10 max-w-5xl mx-auto">
                <button
                    onClick={() => navigate("/admin/press")}
                    className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
                >
                    <ChevronLeft size={16} /> BACK TO PRESS
                </button>

                <div className="mb-10">
                    <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                        Add Press Coverage
                    </h1>
                    <p className="text-black dark:text-white/50 text-sm italic font-serif">
                        Log a new publication, review, or feature.
                    </p>
                </div>

                <PressForm onSubmit={handlePublish} />
            </div>
    );
}
